import * as OrderMiscCommon from './clientlogs/order-misc-common-txtpb'
import { wrapObjectMethodsWithLogging } from './utils'

export const CartOrderPageLog = wrapObjectMethodsWithLogging(OrderMiscCommon.CartOrderPageLog)
export const CartOrderCompletePageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderCompletePageLog
)
export const CartOrderListPageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderListPageLog
)
export const CartOrderDetailPageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderDetailPageLog
)
export const CartOrderCancelPageLog = wrapObjectMethodsWithLogging(
  OrderMiscCommon.CartOrderCancelPageLog
)
